import React, { Component } from 'react'
import SimpleModal from "../../common/components/simple-modal";
import UserAvatar from "../../avatars/components";
import UserProfileLink from "../../common/components/user-profile-link";

const LikedByModal = React.createClass({
  shouldComponentUpdate: function(nextProps, nextState) {
    return nextProps.isModalOpen !== this.props.isModalOpen;
  },
  render: function() {
    let likedByNodes = [];
    _.each(this.props.likedBy, function(user) {
      likedByNodes.push(
        <li key={user.id}>
          <UserAvatar
            userId={user.id}
            firstName={user.first_name}
            lastName={user.last_name}
            size="small"
          />
          <UserProfileLink
            userId={user.id}
            firstName={user.first_name}
            lastName={user.last_name}
          />
        </li>
      );
    });
    return (
      <SimpleModal
        isOpen={this.props.isModalOpen}
        onCloseClick={this.props.onClose}
        modalClassName="liked-by-modal"
        modalId="liked-by-modal"
        centered={true}
      >
        <h1>People who like this</h1>
        <ul>
          {likedByNodes}
        </ul>
      </SimpleModal>
    )
  }
})

export default LikedByModal;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/liked-by-modal.es6